exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.css
// module id = ../../../../../src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.css
// module chunks = main